import { createAnonymousNewUserAndReturnJwt, verifyFingerprintAndRenewJwtIfNeeded } from '@/server-actions/embed'
import { wrapServerActionCall } from '@/server-actions/wrapServerAction'
import { getFingerprint } from '@thumbmarkjs/thumbmarkjs'
import { JWT_LOCALSTORAGE_KEY } from './consts'

export async function anonymousAuth() {
  try {
    const fingerprint = await getFingerprint()
    const storedJwt = localStorage.getItem(JWT_LOCALSTORAGE_KEY)

    if (storedJwt) {
      const { jwt, isNew } = await wrapServerActionCall(verifyFingerprintAndRenewJwtIfNeeded)(storedJwt, fingerprint)

      if (isNew) localStorage.setItem(JWT_LOCALSTORAGE_KEY, jwt)

      return { success: true, payload: jwt }
    }

    const token = await wrapServerActionCall(createAnonymousNewUserAndReturnJwt)(fingerprint)
    localStorage.setItem(JWT_LOCALSTORAGE_KEY, token)

    return { success: true, payload: token }
  } catch (error: unknown) {
    return { success: false, payload: error }
  }
}
